export default {"src":"/_next/static/image/public/images/flags/flag_266.076b5b023be53d39706957f43f8db075.svg","height":16,"width":24};